import { useEffect, useState } from 'react';
import { IS_DEMO, IS_LAXMI_HOST } from './demo';

// Which menu pages belong to which feature switch. The gateway sends the live mapping as flags._menu
// (edited in the control panel's catalog); this built-in copy is only the fallback. Pages not listed are always shown.
const FEATURE_PATHS = {
  billing: ['/renewals', '/payments'],
  gst: ['/gst-billing'],
  whatsapp: ['/whatsapp-inbox', '/whatsapp-api', '/kapso', '/messaging'],
  complaints: ['/complaints', '/service-requests', '/connection-requests', '/reconnection-calls', '/discontinued-catv', '/admin-lookup'],
  devices: ['/devices', '/technical', '/olt', '/acs', '/fiber-map', '/stb-inventory'],
  reports: ['/reports', '/insights', '/collection-sheet'],
  import: ['/history-import', '/balance-update', '/needs-plan', '/sync-import', '/link-customers', '/export-contacts'],
  agent: ['/agent-collection'],
  claude: ['/claude-chat'],
  ads: ['/ads'],
};

// true when this menu target belongs to a feature that is switched off
export function featureOff(to, flags) {
  const path = String(to || '').split('?')[0];
  return Object.entries(flags._menu || FEATURE_PATHS).some(([k, prefixes]) =>
    flags[k] === false && prefixes.some(p => path === p || path.startsWith(`${p}/`) || path.startsWith(`${p}-`)));
}

let pending; // one fetch per page load
// {} (everything on) until the gateway answers; Laxmi's own hosts and the demo never ask.
export function useFeatureFlags() {
  const [flags, setFlags] = useState({});
  useEffect(() => {
    if (IS_DEMO || IS_LAXMI_HOST) return;
    pending = pending || fetch('/features.json', { cache: 'no-store' }).then(r => (r.ok ? r.json() : {})).catch(() => ({}));
    pending.then(setFlags);
  }, []);
  return flags;
}
